import { cn } from '@/lib/utils'

type LicensePlateProps = {
  registrationNumber: string
} & React.HTMLAttributes<HTMLDivElement>

const LicensePlate = ({ registrationNumber, className, ...props }: LicensePlateProps) => {
  return (
    <div
      className={cn(
        'inline-flex shrink-0 items-center border border-black dark:border-[#006AA7] bg-white rounded-[3px] overflow-hidden w-fit',
        className,
      )}
      {...props}
    >
      <div className="py-1 px-1.5 pl-2 border-l-5 border-[#006AA7] text-black font-bold text-sm tracking-wider font-mono tabular-nums">
        {registrationNumber}
      </div>
    </div>
  )
}

export default LicensePlate
